export { default as settings } from './settings';

export { default as contentFields } from './contentFields';
export { default as DefaultRegistration } from './defaultRegistration';
